import React from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const EducationLoanPage = () => {
    return (
        <>
            <div className="container mt-10">
                <div className="row gap-6 flex-row flex">
                    <div className="col-12 md:col-6 w-full">
                        <Card>
                            <CardHeader>
                                <CardTitle>Documents Required</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>5 Photographs</li>
                                    <li>Address Proof</li>
                                    <li>ID Proof</li>
                                    <li>2 Stamp Papers of Rs.50/- in favor of the Applicant</li>
                                    <li>Bank Statement of last 6 months</li>
                                    <li>File Charge Rs. 6500/-</li>
                                    <li>Property Papers (Khasra, Khatauni, Registry, Bainama)</li>
                                </ul>
                            </CardContent>
                        </Card>
                    </div>

                    <div className="col-12 md:col-6 w-full">
                        <Card>
                            <CardHeader>
                                <CardTitle>Type of Guarantor</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>Government Guarantor</li>
                                    <li>Private Limited Guarantor</li>
                                    <li>Property Guarantor</li>
                                </ul>
                            </CardContent>
                        </Card>
                    </div>
                </div>

                <Card className="mt-6">
                    <CardHeader>
                        <CardTitle>Documents Valid as ID Proof</CardTitle>
                    </CardHeader>
                    <CardContent className="grid md:grid-cols-2 gap-6">
                        <ul className="list-disc pl-5 space-y-2">
                            <li>PAN Card</li>
                            <li>Voter Card</li>
                            <li>Driving License</li>
                        </ul>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Job Certificate (current)</li>
                            <li>College Identity Card</li>
                        </ul>
                    </CardContent>
                </Card>
            </div>
        </>
    );
};

export default EducationLoanPage;
